import OspreyAccounts from './api-accounts'
import OspreyCommunication from './api-communication'
import OspreyMe from './api-me'
import OspreyUsers from './api-users'
import OspreySilos from './api-silos'
import OspreyImages from './api-images'
import OspreyTags from './api-tags'
import OspreyAffiliations from './api-affiliations'
import OspreyTemplates from './api-templates'
import OspreyMessages from './api-messages'
import OspreyContentBlocks from './api-content-blocks'
import OspreyOffers from './api-offers'
import OspreyAudience from './api-audiences'
import OspreyTestMessage from './api-test-message'
import OspreyTestSend from './api-test-send'
import OspreySummaryReports from './api-summary-reports'
import OspreyTypedValues from './api-typed-values'

export default class OspreyApiService {

    static get accounts() {
        return OspreyAccounts
    }

    static get me() {
        return OspreyMe
    }

    static get users() {
        return OspreyUsers
    }

    static get silos() {
        return OspreySilos
    }

    static get images() {
        return OspreyImages
    }

    static get tags() {
        return OspreyTags
    }

    static get affiliations() {
        return OspreyAffiliations
    }

    static get templates() {
        return OspreyTemplates
    }

    static get communication() {
        return OspreyCommunication
    }

    static get messages() {
        return OspreyMessages
    }

    static get 'content-blocks'() {
        return OspreyContentBlocks
    }

    static get offers() {
        return OspreyOffers
    }

    static get audiences() {
        return OspreyAudience
    }

    static get testMessage() {
        return OspreyTestMessage
    }

    static get 'test-emails'() {
        return OspreyTestSend
    }

    static get 'summary-reports'() {
        return OspreySummaryReports
    }

    static get 'typed-values'() {
        return OspreyTypedValues
    }
}



// WEBPACK FOOTER //
// src/services/osprey-api/index.js